import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { seguimientoAnonimoGatewayUrl } from '../base/url.seguimiento-anonimo.gateway';
import { GatewayHttpLoggingService } from '../logging/gateway-http-logging.service';

export interface SeguimientoAnonimoGatewayPostOptions {
  headers?: HttpHeaders;
}

/**
 * Cliente HTTP hacia el API Gateway de seguimiento anónimo.
 * El header `Authorization: Bearer` lo aplica {@link AnonymousGatewayBearerInterceptor}.
 */
@Injectable({ providedIn: 'root' })
export class SeguimientoAnonimoGatewayHttpService {
  constructor(
    private readonly http: HttpClient,
    private readonly gatewayLog: GatewayHttpLoggingService
  ) {}

  post<T>(
    relativePath: string,
    body: unknown | null | undefined = {},
    options?: SeguimientoAnonimoGatewayPostOptions
  ): Observable<T> {
    const payload = body === undefined ? {} : body;
    const url = seguimientoAnonimoGatewayUrl(relativePath);
    let headers = options?.headers || new HttpHeaders();
    if (payload instanceof FormData) {
      headers = headers.delete('Content-Type');
    } else if (payload !== null) {
      headers = headers.set('Content-Type', 'application/json');
    }
    return this.http.post<T>(url, payload, { headers }).pipe(
      catchError((err: HttpErrorResponse) => {
        this.gatewayLog.logHttpError(err);
        return throwError(err);
      })
    );
  }
}
